











































import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { Button, Input, Form, FormItem } from 'element-ui';
import { authenticationService } from '@/services/AuthenticationService';
// Types
import { FetchResult } from 'apollo-link';
import { ApolloQueryResult } from 'apollo-client';
import { authenticateUser_authenticateUser } from '@/types/graphql/schemaTypes';

// rules
import rules from '@/rules/rules';

// Lodash
import get from 'lodash/get';

import { i18n } from '@/plugins/i18n';

@Component({
  components: {
    'el-button': Button,
    'el-input': Input,
    'el-form': Form,
    'el-form-item': FormItem
  }
})
export default class Login extends Vue {
  private loginData = {
    email: '',
    password: ''
  }

  private isLoading = false;

  private readonly rules = rules;

  $refs!: {
    loginForm: HTMLFormElement;
  };

  private login() {
    this.$refs.loginForm.validate(async(valid: boolean) => {
      if (!valid) {
        return;
      }

      this.isLoading = true;
      try {
        const response = await authenticationService.login({
          email: this.loginData.email,
          password: this.loginData.password,
          role: 'operator'
        });
        if (response) {
          this.$router.push({ name: 'shipments' });
        }
      } catch (error) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('users.login.error.login'),
          time: 3000
        });
      } finally {
        this.isLoading = false;
      }
    });
  }
}
